import React from "react";
import { useGiteaConfiguredPolled } from "../../hooks/useIntegrationStatus";

const buildTitle = ({ checking, configured, error, httpStatus, latencyMs }) => {
  const parts = [];
  if (checking) parts.push("Gitea check bezig…");
  else if (error) parts.push("Gitea fout");
  else if (configured === false) parts.push("Gitea niet geconfigureerd");
  else if (configured === true) parts.push("Gitea werkt");
  else parts.push("Gitea status onbekend");
  if (httpStatus != null) parts.push(`HTTP ${httpStatus}`);
  if (latencyMs != null) parts.push(`${latencyMs}ms`);
  return parts.join(" • ");
};

export default function GiteaStatusDot({ showLabel = true } = {}) {
  const snapshot = useGiteaConfiguredPolled(true);
  const configured = snapshot?.data?.configured ?? null;
  const loading = Boolean(snapshot?.loading);
  const error = snapshot?.error ?? null;
  const meta = snapshot?.meta ?? { httpStatus: null, latencyMs: null };

  const checking = loading || configured == null;
  const title = buildTitle({
    checking,
    configured,
    error,
    httpStatus: meta.httpStatus,
    latencyMs: meta.latencyMs,
  });

  const dotClass =
    checking
      ? "bg-amber-500 shadow-[0_0_0_4px_rgba(245,158,11,0.18)]"
      : configured === true
        ? "bg-emerald-500 shadow-[0_0_0_4px_rgba(16,185,129,0.18)]"
        : configured === false
          ? "bg-rose-500 shadow-[0_0_0_4px_rgba(244,63,94,0.18)]"
          : "bg-rose-500 shadow-[0_0_0_4px_rgba(244,63,94,0.18)]";

  return (
    <div className="flex items-center gap-2" title={title} aria-label={title}>
      <span className={`h-3 w-3 rounded-full ${dotClass}`} />
      {showLabel && (
        <span className="inline-flex items-center gap-1 text-sm font-semibold text-gray-600 dark:text-gray-300">
          Gitea
        </span>
      )}
    </div>
  );
}
